import type { SortOption } from '@/constants/community';

/** The order the library list asks the API for. */
export type LibraryListSortBy = 'publishedAt' | 'likes' | 'comments';

/**
 * Maps the sort a reader picked to the one the list is fetched and cached by.
 *
 * The saved view is unsorted, so it maps to nothing whatever is picked. Every
 * cache patch must derive the list key through here, or an optimistic update
 * lands on a list the reader is not looking at.
 */
export function communityPostsSortByForQuery(
  showSavedPosts: boolean | undefined,
  sortBy: SortOption | undefined
): LibraryListSortBy | undefined {
  if (showSavedPosts) {
    return undefined;
  }

  if (sortBy === 'newest') {
    return 'publishedAt';
  }

  return sortBy;
}
